<template>
  <div class="table-container">
    <div class="table-responsive table-scrollable" v-if="items?.length > 0">
      <table class="table table-striped">
        <thead>
        <tr>
          <th class="sticky-header">ردیف</th>
          <th v-for="(header, index) in headers" :key="index" class="sticky-header">{{ header }}</th>
          <th class="sticky-header">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ index + 1 }}</td>
          <td v-for="field in fields" :key="field">{{ item[field] ?? '...' }}</td>
          <td class="nowrap vw-8">
            <a
                type="button"
                v-if="openEditModalMethod"
                @click="openEditModalMethod(item, index)"
            >
              <img class="table-edit-img" src="@/assets/img/pen.svg" alt="edit" title="ویرایش">
            </a>
            <a type="button" class="ms-2" @click="openDeleteModal(index)">
              <img class="table-delete-img" src="@/assets/img/delete.svg" alt="delete" title="حذف">
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="alert alert-info" style="padding: 1.8vw">
      موردی وجود ندارد
    </div>

    <ConfirmModal
        ref="confirmModal"
        v-show="deleteIndex"
        title="حذف"
        message="آیا از حذف مطمئن هستید؟"
        @closed="closeModal"
        @confirmed="confirmRemove"
    />
  </div>
</template>

<script>
import ConfirmModal from "@/components/JobDescription/GeneralComponents/ConfirmModal.vue";

export default {
  components: {ConfirmModal},
  props: {
    headers: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    openEditModalMethod: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      deleteIndex: null
    }
  },
  methods: {
    openDeleteModal(index) {
      this.deleteIndex = index;
      this.$refs.confirmModal.openConfirmModal()
    },
    closeModal() {
      this.deleteIndex = null;
    },
    confirmRemove() {
      this.$emit('remove', this.deleteIndex);
      this.deleteIndex = null;
    }
  }
};
</script>

<style scoped>
.table-scrollable {
  max-height: 11vw;
  min-height: 11vw;
  overflow-y: auto;
  margin-top: 1vw;
}

.sticky-header {
  position: sticky;
  top: -.2vw;
  z-index: 10;
}
</style>
